import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { SUPPORTED_LANGUAGES } from './supportedLanguages'

const supportedLngs = SUPPORTED_LANGUAGES.map(l => l.code)

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs,
        load: 'languageOnly', // strips region codes: 'hi-IN' → 'hi', 'kn-IN' → 'kn'
        debug: process.env.NODE_ENV === 'development',

        detection: {
            order: ['localStorage', 'navigator'], // 1st: user's saved choice, 2nd: OS language
            caches: ['localStorage'],             // persist manual language selection
        },

        ns: ['common', 'nav', 'auth', 'dashboard', 'chat'],
        defaultNS: 'common',

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n
